<template>
  <div class="home-wrap">
    <div class="padding-11-15 padding-b-19">
      <div class="title-text-official">网站推广</div>
    </div>
    <div class="promote-link-box">
      <div class="padding-15">
        <div class="link-box">
          <div class="link-title">我的推广链接：</div>
          <div class="link">{{ promote_link }}</div>
        </div>
        <div class="copy-div"
             v-clipboard:copy="promote_link"
             v-clipboard:success="onCopy"
             v-clipboard:error="onError">复制邀请链接</div>
        <div class="link-desc"><span class="font-11">为保证推荐人关系不丢失，请复制完整的邀请链接</span></div>
      </div>
    </div>
    <div class="padding-0-15 padding-b-8">
      <div class="table-wrapper">
        <el-table :data="list" border style="width: 100%">
          <el-table-column prop="date" label="序号" width="53" align="center">
            <template slot-scope="{row}">
              <span>{{ row.sequence }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="我推荐的好友" width="100" align="center">
            <template slot-scope="{row}">
              <span>{{ row.nickname }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="注册时间" width="90" align="center">
            <template slot-scope="{row}">
              <span>{{ row.registerTimeStr }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="已购套餐详情" width="100" align="center">
            <template slot-scope="{row}">
              <span class="color-ff4" style="cursor: pointer;color: #3D9EFC;" @click="showDetail(row)">查看详情</span>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :page.sync="searchForm.page" :limit.sync="searchForm.pagesize" @pagination="getList" />
      </div>
    </div>
    <Detail ref="Detail" v-show="isShowDetail"></Detail>
  </div>
</template>

<script>
import Detail from '@/views/h5/official/invite/modal/Detail'
import Pagination from '@/components/h5/Pagination' // secondary package based on el-pagination
import { getUserUUID } from '@/utils/auth'
import invite from '@/javaApi/invite'
const inviteModel = new invite()
export default {
  name: "Invite",
  components: {
    Pagination,
    Detail
  },
  data: function () {
    return {
      promote_link: location.href.replace(this.$route.path,'') + "/pc/home?invite_code="+getUserUUID(),
      listLoading: false,
      list:[],
      total:0,
      isShowDetail: false,
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        userUUID: getUserUUID()
      }
    }
  },
  mounted: function () {
    localStorage.setItem('inviteCode',getUserUUID())
  },
  created() {
    this.getList(true)
  },
  methods: {
    getList(first = false){
      this.listLoading = true
      if(first) this.searchForm.pageNo = 1
      let searchForm = Object.assign({}, this.searchForm)
      inviteModel.getInviteList(searchForm).then((response) => {
        this.listLoading = false
        let res = response.data
        if(res.code != 200){
          this.$Message.error(res.message)
          return
        }
        this.list = this.formateData(res.data.list);
        this.total = res.data.total;
      })

    },
    formateData(data){
      if(!data){
        return []
      }
      if(!data.length){
        return []
      }
      let i = 0;
      let pageNo = this.searchForm.pageNo
      let pageSize = this.searchForm.pageSize
      for(i=0;i<data.length;i++){
        data[i].sequence = (i+1)+(pageNo - 1)*pageSize
      }
      return  data
    },
    changePage(value) {
      this.searchForm.pageNo = value
      this.getList()
    },
    changePagesize(value) {
      this.searchForm.pageSize = value
      //如果处于第一页改变数量，则会触发changePage
      if (this.searchForm.pageNo == 1) {
        this.getList()
      }
    },
    //复制
    onCopy: function(e) {
      this.$Message.success('复制成功');
    },
    onError: function(e) {
      this.$Message.success('复制失败');
    },
    showDetail: function (row) {
      this.isShowDetail = true;
      this.$refs.Detail.init(true, row);
    }
  }
}
</script>

<style lang="less" scoped>
.home-wrap{
  font-family: Alibaba-PuHuiTi-R;
  .promote-link-box{
    background: #FAFAFA;
    border-radius: 4px;
    margin: 0 15px 15px;
    .link-box{
      display: flex;
      font-size: 12px;
      .link-title{
        color: #222222;
        width: 83px;
        white-space: nowrap;
      }
      .link{
        color: #3D9EFC;
        word-break:break-all;
      }
    }
    .copy-div{
      margin: 20px auto 12px;
      text-align: center;
      background: #FF8622;
      border-radius: 18px;
      padding: 7px 0;
      font-size: 16px;
      color: #FFFFFF;
      width: 87.30%;
    }
    .link-desc{
      color: #999999;
      text-align: center;
    }
  }
  .table-wrapper {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/h5/official/invite/Index.vue